import { Download, Share2, X } from "lucide-react";

export function InstallPrompt({
  isiOS,
  canPrompt,
  onInstall,
  onDismiss
}: {
  isiOS: boolean;
  canPrompt: boolean;
  onInstall: () => Promise<boolean>;
  onDismiss: () => void;
}) {
  return (
    <aside className="install-banner" aria-labelledby="install-title">
      <div className="install-mark" aria-hidden="true">
        <Download />
      </div>
      <div>
        <strong id="install-title">Installer ParleNote</strong>
        <span>
          {isiOS && !canPrompt
            ? "Touchez Partager, puis « Sur l’écran d’accueil »."
            : "Un accès rapide, comme une vraie app, sans passer par le store."}
        </span>
      </div>
      {isiOS && !canPrompt ? (
        <Share2 className="install-share" aria-hidden="true" />
      ) : (
        <button className="button compact primary" type="button" onClick={() => void onInstall()}>
          Installer
        </button>
      )}
      <button className="icon-button install-close" type="button" onClick={onDismiss} aria-label="Plus tard">
        <X aria-hidden="true" />
      </button>
    </aside>
  );
}
